import produce from 'immer';

import * as classConstants from 'common.components/classes/constants';
import { ClassesActions } from 'common.components/classes/typings';

import * as constants from './constants';
import { ClassActions, ClassState } from './typings';

export const initialState: ClassState = {
    classIdToDelete: null,
    submittingChanges: false,
    controlsStatus: false,
    isArchivateClassModalOpened: false,
    isClassNameEditorModalOpened: false,
    isAddingNewStudent: false,
    isStudentsListModalOpened: false,
    shouldRedirect: false,
    classItemToArchive: null,
    createdTeamId: null,
};

const classReducer = (state: ClassState = initialState, action: ClassActions | ClassesActions) => {
    return produce(state, (draft) => {
        // eslint-disable-line complexity
        switch (action.type) {
            case classConstants.SET_NAME_SUCCESS:
                draft.isClassNameEditorModalOpened = false;
                break;

            case constants.TOGGLE_CLASS_NAME_EDITOR_MODAL: {
                draft.isClassNameEditorModalOpened = action.isOpen;
                break;
            }

            case constants.TOGGLE_ARCHIVATE_CLASS_MODAL: {
                draft.isArchivateClassModalOpened = action.isOpen;
                break;
            }

            // TODO: еще надо?
            case constants.SET_SHOULD_REDIRECT: {
                draft.shouldRedirect = action.shouldRedirect;
                draft.createdTeamId = action.createdTeamId;
                break;
            }

            case constants.SET_CLASS_ID_TO_DELETE: {
                draft.classIdToDelete = action.id;
                break;
            }

            case constants.SET_CLASS_ITEM_TO_ARCHIVE: {
                draft.classItemToArchive = action.classItem;
                break;
            }

            default:
                break;
        }
    });
};

export default classReducer;
